import { ReactElement } from "react";
import { PageContainer, PageTitle } from "../../global/Common";
import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";
import { useBrand } from "../../context/BrandContext";

const CGU = (): ReactElement => {
  const { t } = useLanguage();
  const { theme } = useBrand();

  const articles = [1, 2, 3, 4, 5, 6, 7];

  return (
    <PageContainer>
      <PageTitle>{t('pages.cgu.title')}</PageTitle>
      
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <i className="bx bx-file-blank" style={{ fontSize: 24, color: theme.primary }} />
              {t('pages.cgu.generalConditions')}
            </Typography>
            <Divider sx={{ mb: 3 }} />
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {articles.map(num => (
                <Box key={num}>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                    {t(`pages.cgu.article${num}.title`)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'justify' }}>
                    {t(`pages.cgu.article${num}.content`)}
                  </Typography>
                </Box>
              ))}

              <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  {t('pages.cgu.lastUpdate')}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </PageContainer>
  );
};

export default CGU;
